import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { HistoricRoutingModule } from './historic.routing';
import { HistoricComponent } from './historic/historic.component';
import { HistoricMapComponent } from './historic-map/historic-map.component';
import { HistoricPopupComponent } from './historic-popup/historic-popup.component';
import { HistoricContextService } from './historic-context.service';
import { CommonModule } from '../common/common.module';
import { NgSelectModule } from '@ng-select/ng-select';
import {MapContextService} from 'app/common/map-context.service';
import {MobilePopupComponent} from './mobile-popup/mobile-popup.component';
import {HistoricLegendComponent} from './historic-legend/historic-legend.component';
import {FormsModule} from '@angular/forms';
import { HistoricDetailLevelComponent } from './historic-detail-level/historic-detail-level.component';

@NgModule({
  imports: [
    NgCommonModule,
    CommonModule,
    HistoricRoutingModule,
    NgSelectModule,
    FormsModule
  ],
  declarations: [
    HistoricMapComponent,
    HistoricComponent,
    HistoricPopupComponent,
    MobilePopupComponent,
    HistoricLegendComponent,
    HistoricDetailLevelComponent
  ],
  providers: [MapContextService, HistoricContextService],

  entryComponents: [HistoricPopupComponent]
})
export class HistoricModule { }



// WEBPACK FOOTER //
// ./src/app/historic/historic.module.ts